import React from "react";
import PropTypes from "prop-types";

import { ErrorBanner } from "./styles";

import { getFormattedBytes } from "./helpers";

const DroppedFileErrors = ({
    minFileSizeBytes,
    maxFileSizeBytes,
    hasRejectedFileErrors,
    handleClearErrors,
    rejectedFilesCount,
    initialMaximumFiles
}) => {
    const FILE_INVALID_TYPE = "file-invalid-type";
    const FILE_TOO_LARGE = "file-too-large";
    const FILE_TOO_SMALL = "file-too-small";
    const TOO_MANY_FILES = "too-many-files";

    if (rejectedFilesCount === 0) return null;

    const maxLimitUploadError = (
        <>
            You can include up to {initialMaximumFiles} photos in this
            submission.
        </>
    );

    const hasTooManyFiles = hasRejectedFileErrors
        .map(res => res.errors) // map over array of files with errors
        .flatMap(error => error) // map over objects inside errors array
        .filter(theError => theError.code === TOO_MANY_FILES); // make sure the error code is "TOO_MANY_FILES"

    //if error === too many files, only return one banner:
    if (hasTooManyFiles.length > 0) {
        return (
            <ErrorBanner
                styleType="solid"
                infoType="error"
                handleDismissClick={handleClearErrors}
                dismissTimerSeconds={4}
            >
                {maxLimitUploadError}
            </ErrorBanner>
        );
    }

    // return banners for each of the other types of errors:
    return hasRejectedFileErrors.map(file => {
        const minumumFileSizeAllowed = getFormattedBytes({
            bytes: minFileSizeBytes
        });

        const maximumFileSizeAllowed = getFormattedBytes({
            bytes: maxFileSizeBytes
        });

        const totalFileSize = getFormattedBytes({
            bytes: file.size
        });

        return file.errors.map(error => {
            const fileSizeTooSmallError = `The minumum allowed file size is ${minumumFileSizeAllowed}. Your attempted upload of "${file.name}" was ${totalFileSize}. Please correct the issue and try again.`;

            const fileSizeTooBigError = `The total allowed file size is ${maximumFileSizeAllowed}. Your attempted upload of "${file.name}" was ${totalFileSize}. Please correct the issue and try again.`;

            const fileInvalidError = `${error.message}. Please remove "${file.name}" and try again.`;

            if (error.code === FILE_TOO_SMALL) {
                return (
                    <ErrorBanner
                        key={file.index}
                        styleType="solid"
                        infoType="error"
                        handleDismissClick={handleClearErrors}
                        dismissTimerSeconds={4}
                    >
                        {fileSizeTooSmallError}
                    </ErrorBanner>
                );
            }

            if (error.code === FILE_TOO_LARGE) {
                return (
                    <ErrorBanner
                        key={file.index}
                        styleType="solid"
                        infoType="error"
                        handleDismissClick={handleClearErrors}
                        dismissTimerSeconds={4}
                    >
                        {fileSizeTooBigError}
                    </ErrorBanner>
                );
            }

            if (error.code === FILE_INVALID_TYPE) {
                return (
                    <ErrorBanner
                        key={file.index}
                        styleType="solid"
                        infoType="error"
                        handleDismissClick={handleClearErrors}
                        dismissTimerSeconds={4}
                    >
                        {fileInvalidError}
                    </ErrorBanner>
                );
            }
        });
    });
};

DroppedFileErrors.propTypes = {
    minFileSizeBytes: PropTypes.number.isRequired,
    maxFileSizeBytes: PropTypes.number.isRequired,
    hasRejectedFileErrors: PropTypes.array.isRequired,
    handleClearErrors: PropTypes.func.isRequired,
    rejectedFilesCount: PropTypes.number.isRequired,
    initialMaximumFiles: PropTypes.number.isRequired
};

export default DroppedFileErrors;
